module.exports = __webpack_public_path__ + "static/media/hero_desktop.81a75b53.webp";